/**
 * Profiles SoT typography / density for Profile edit section cards.
 * Prefer SettingsGroup* (Phase 7) over CardTitle + CardDescription essays.
 */

export const PROFILE_EDIT_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight tracking-normal text-foreground';

export const PROFILE_EDIT_SECTION_MUTED_CLASS =
  'text-[13.5px] leading-relaxed text-muted-foreground';

/** @deprecated Prefer SettingsGroupRow padding (Phase 7 density). */
export const PROFILE_EDIT_SECTION_CARD_HEADER_CLASS =
  'px-5 pt-5 sm:px-6 sm:pt-6';

/** @deprecated Prefer SettingsGroupRow padding (Phase 7 density). */
export const PROFILE_EDIT_SECTION_CARD_CONTENT_CLASS =
  'px-5 pb-5 sm:px-6 sm:pb-6';
